import { connect } from 'react-redux';
import { AppState } from '../../../../../types/store';
import { getProfileOwnerIsWatcher } from '../../../../selectors/users';

export default connect((state: AppState) => ({
  isProfileOwnerWatchingCurrentUser: getProfileOwnerIsWatcher(state),
}));
